var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sys-user-table',{attrs:{"client-type":"app","title":"User List","create-text":"New User","entity-name":"user"}})
}
var staticRenderFns = []

export { render, staticRenderFns }